import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Field, reduxForm } from 'redux-form'
import { Link } from 'react-router-dom'

import { 
  tryToLogin, 
  tryToLoginMFA,
  tryToSendLoginMFAEmail,
  logOut,
} from '../../actions/actions.export.js';

import Button from '../Button/Button.js'
import MFAPinField from '../MFAPinField/MFAPinField.js'
import CustomField from '../CustomField/CustomField.js'

import './LoginForm.css';

const getUrlParams = () => {
  var urlParams;
  var match,
      pl     = /\+/g,  // Regex for replacing addition symbol with a space
      search = /([^&=]+)=?([^&]*)/g,
      decode = function (s) { return decodeURIComponent(s.replace(pl, " ")); },
      query  = window.location.search.substring(1);

  urlParams = {};
  while (match = search.exec(query))
     urlParams[decode(match[1])] = decode(match[2]);

  return urlParams;
}

class LoginForm extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired

  }

  constructor(props){
    super(props);

    this.state = {
      email: props.user.loginForm.lastSubmit.email,
      password: props.user.loginForm.lastSubmit.password,
      mfa: false,
      mfa_mode: 'app'
    }

    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentWillReceiveProps(newprops){
    if(newprops.user.mfa && !this.state.mfa){
      this.setState({
        mfa: true,
        mfa_mode: newprops.user.mfa_app_enabled ? 'app' : 'email'
      })
    }
  }

  handleSubmit(e){
    const { dispatch } = this.props; 
    dispatch(tryToLogin(this.state));
    if(e) e.preventDefault();
  }

  render(){
    const { user, dispatch } = this.props; 
    const state = this.state;

    var urlParams = getUrlParams();

    let formDisabled = !state.password || !state.email;

    if(user.isLoggedIn){
      return <div className="flex-center-column">
        <p>
          You're currently logged in.
        </p>
        <Button display="Log Out" onClick={()=>{ dispatch(logOut())}}/>
      </div>
    }


    return (
      <div className="login-form">
        
        {
          user.mfa ? 
          <div>
            {
              this.state.mfa_mode === 'app' && 
              <p className="text-center p-push-down">
                Please use your configured<br/>authentication app to generate a pin:
              </p>
            }
            {
              this.state.mfa_mode === 'email' && 
              <p className="text-center p-push-down">
                An email is heading your way,<br/>please enter the included pin below:
              </p>
            }

            <div className="flex-center-column">
              <MFAPinField onComplete={(code) => {
                  dispatch(tryToLoginMFA({mfa_mode: this.state.mfa_mode, code: code}))
                }}
                thinking={user.tryingToLoginMFA}
                failed={user.failedToLoginMFA}
                successful={user.successfullyLoggedInMFA}
                />
              
              <hr/>
              {
                (user.mfa_email_enabled && user.mfa_app_enabled) &&
                <div>
                  {
                    this.state.mfa_mode === 'email' && 
                      <Button 
                        display="Use App Instead"
                        color="grey"
                        thinking={user.tryingToLoginMFA}
                        onClick={() => {
                          this.setState({
                            mfa_mode: 'app'
                          })
                        }}
                        />
                  }
                  {
                    this.state.mfa_mode === 'app' && 
                      <Button 
                        display="Use Email Instead"
                        color="grey"
                        thinking={user.tryingToLoginMFA}
                        onClick={() => {
                          this.setState({
                            mfa_mode: 'email'
                          })
                          if(!user.lastSentMFAEmail || (new Date().getTime() - user.lastSentMFAEmail) > 5*60*1000){
                            dispatch(tryToSendLoginMFAEmail())
                          }
                        }}
                        />
                  }
                </div>
              }
            </div>
          </div>
          :
          
          <form name="LoginForm" onSubmit={(e) => {
            e.preventDefault();
            if(!formDisabled) this.handleSubmit(e);
          }}>

            <CustomField 
              type="text"
              regex="email"
              name="email"
              placeholder="email address"
              label="Email Address"
              value={state.email}
              onChange={(e) => {this.setState({email: e}); }}
              serverErrors={user.loginForm.errors.email}
              required={true}
              disabled={user.tryingToLogin}
              autoFocus={true}
            />
            
            <CustomField 
              type="password"
              name="password"
              placeholder="password"
              label="Password"
              value={state.password}
              onChange={(e) => {this.setState({password: e}); }}
              serverErrors={user.loginForm.errors.password}
              required={true}
              disabled={user.tryingToLogin}
            />

            <div className="text-center">
              <br/>
              
              <Button 
                submit={true} 
                disabled={formDisabled} 
                thinking={user.tryingToLogin} 
                successful={user.successfullyLoggedIn}
                failed={user.failedToLogin}
                display="Log In" 
                size="large" 
                block={true}
                color="success"
              />
            </div>
            <div className="agree-wrapper">
              <div className="agree-text">
                <Link to="/forgot">Forgot password<i className="far fa-angle-right fa-fw"/></Link>
              </div>
            </div>
            <div className="agree-wrapper">
              <div className="agree-text">
                <Link to={"/sign-up" + (urlParams.after ? "?after=" + urlParams.after : "")}>Sign up for a new account<i className="far fa-angle-right fa-fw"/></Link>
              </div>
            </div>
          </form>
        }
      </div>
    )
  }
}

LoginForm = reduxForm({
  form: 'LoginForm',
  enableReinitialize: true,
  destroyOnUnmount: false
})(LoginForm)

LoginForm = connect((state, ownProps) => {
  const { user } = state;

  var initialValues = {
    
  };
  
  return {
    user,
    initialValues
  }
})(LoginForm);

export default LoginForm;



// WEBPACK FOOTER //
// ./src/components/LoginForm/LoginForm.js